/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, May 2022
 * @flow
 */

import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import Checkbox from '../../../../components/Checkbox';
import backImg from '../../../../assets/images/Fireboard/back2_red.png';
import searchIcon from '../../../../assets/images/Fireboard/search_black.png';
import Toggle from '../../../../components/Toggle';
import strings from '../../../../globalization';
import classes from './Header.module.css';

const Header = props => {
  const {
    goBack,
    sectionView,
    toggleCheckbox,
    changeView,
    excludeTerminated,
    jobAllowsAssignment,
    assigned,
  } = props;

  return (
    <div className={classes.headerWrapper}>
      <div className={classes.headerLeftSection}>
        {window.ReactNativeWebView && <img src={backImg} className={classes.backImage} alt='' onClick={goBack} />}
        <div className={classes.toggleWrapper}>
          <span className={[classes.sortOptions, classes.noMargin].join(' ')}>{strings.employeeView}</span>
          <Toggle selected={!sectionView} onClick={changeView} />
          <span className={classes.sortOptions}>{strings.sectionView}</span>
        </div>
      </div>
      <div className={classes.headerRightSection}>
        <div className={classes.checkboxWrapper}>
          <Checkbox checked={assigned} onChange={toggleCheckbox('assigned')} />
          <span className={classes.sortOptions}>{strings.assigned}</span>
        </div>
        <div className={classes.checkboxWrapper}>
          <Checkbox checked={jobAllowsAssignment} onChange={toggleCheckbox('jobAllowsAssignment')} />
          <span className={classes.sortOptions}>{strings.jobAllowsAssignment}</span>
        </div>
        <div className={classes.checkboxWrapper}>
          <Checkbox checked={excludeTerminated} onChange={toggleCheckbox('excludeTerminated')} />
          <span className={classes.sortOptions}>{strings.excludeTerminated}</span>
        </div>
      </div>
    </div>
  );
};

Header.propTypes = {
  goBack: PropTypes.func.isRequired,
  sectionView: PropTypes.bool,
  toggleCheckbox: PropTypes.func,
  changeView: PropTypes.func,
  excludeTerminated: PropTypes.bool,
  jobAllowsAssignment: PropTypes.bool,
  assigned: PropTypes.bool,
  sortByName: PropTypes.bool,
  onChangeSortByName: PropTypes.func,
};

Header.defaultProps = {
  goBack: () => { },
  sectionView: false,
  toggleCheckbox: () => { },
  changeView: () => { },
  excludeTerminated: true,
  jobAllowsAssignment: true,
  assigned: false,
  sortByName: true,
  onChangeSortByName: () => { },
};

const FilterHeader = ({ sortByName, onChangeSortByName, sectionView, searchEmployeeValue, onSearchEmployee }) => {
  const inputRef = useRef();

  const onSubmit = event => {
    event.preventDefault();
    inputRef.current.blur();
  };

  return (
    <div className={classes.headerWrapper}>
      <div className={classes.toggleWrapper}>
        <span className={[classes.sortOptions, classes.noMargin].join(' ')}>{strings.sortByName}</span>
        <Toggle selected={sortByName} onClick={!sectionView ? onChangeSortByName : null} />
        <span className={classes.sortOptions}>{strings.sortByPOSID}</span>
      </div>
      <div className={classes.inputWrapper}>
        <form onSubmit={onSubmit}>
          <input
            ref={inputRef}
            disabled={sectionView}
            className={classes.input}
            placeholder='Search'
            value={searchEmployeeValue}
            onChange={onSearchEmployee}
          />
        </form>
        <img src={searchIcon} className={classes.searchIcon} alt='search' />
      </div>
    </div>
  );
};

FilterHeader.propTypes = {
  sectionView: PropTypes.bool,
  sortByName: PropTypes.bool,
  onChangeSortByName: PropTypes.func,
  searchEmployeeValue: PropTypes.string,
  onSearchEmployee: PropTypes.func,
};

FilterHeader.defaultProps = {
  sectionView: false,
  sortByName: true,
  onChangeSortByName: () => { },
  searchEmployeeValue: '',
  onSearchEmployee: () => { },
};

export {
  Header,
  FilterHeader,
};
